/* eslint-disable */
import $ from 'jquery';
import debounce from 'lodash.debounce';
import lazy from 'jquery-lazy';
/* eslint-enable */
import Typed from 'typed.js';


export default function () {

    $('.truncated-block').readmore({
        speed: 75,
        lessLink: '<a href="#" class="btn btn-link lime-green-color bold">Read less</a>',
        moreLink: '<a href="#" class="btn btn-link lime-green-color bold">Read more</a>'
    });

    $('.lazy').lazy({
        // called before an elements gets handled
        beforeLoad: function (element) {
            let backgroundX = element.data('focus-x');
            let backgroundY = element.data('focus-y');
            let result = String(backgroundX + ' ' + backgroundY);
            element.css('background-position', result);
        },
        effect: 'fadeIn',
        effectTime: 1000,
        threshold: 0
    });

    $('.linkable').on("click", function () {
        let $this = $(this);
        window.location = $this.attr('data-link');
    });

    /*let typed = new Typed('#typed', {
        stringsElement: '#typed-strings',
        typeSpeed: 40,
        showCursor: false
    });*/


    $(document).ready(function () {
       // setTimeout(
        //    function()
        //    {
                $(".reveal").toggleClass("show");
         //   }, 5000);


    });


}
